





































































































































































































































import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import { WithConfirmModal } from '@/components/organisms/confirm-modal/with-confirm-modal'
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'

import { log } from '@/log'

import { ApiContent } from '@/models/api/content'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { CartItemList } from '@/models/cart/cart-item'
import { isDisplayItem } from '@/models/cart/group/group'
import { CartScopeEq } from '@/models/cart/group/scope'
import CleanUpUnpublishedNoveltyItemObserver from '@/models/cart/novelty/clean-up-unpublished-novelty-item-observer'
import { CommandToSaveNoveltySpec } from '@/models/cart/novelty/command-to-save-novelty-spec'
import { CartItemRepository } from '@/models/cart/repository/cart-item-repository'
import { EngineCartRepository } from '@/models/cart/repository/impl/cart-item/engine-cart-item-repository'
import RemoveItemFromCartService from '@/models/cart/service/remove-item-from-cart-service'
import { RestoreRemovedItemFromCartService } from '@/models/cart/service/restore-removed-item-from-cart-service'
import { UpdateItemCountInCartService } from '@/models/cart/service/update-item-count-in-cart-service'
import { NoveltyCampaign } from '@/models/novelty/novelty'
import { ContextFactory } from '@/models/order-history/status/context/context'
import ShippingFee from '@/models/shipping-fee'
import SelectShippingFee from '@/models/shipping-fee/select'
import { ContextToCreateUrl, createItemListUrl } from '@/page/url/factory/url-factory'

import BundleDiscountService, {
  AppliedBundleDiscount,
  BundleDiscountWithBrand,
  convertToApplyBundleDiscountParamter,
} from '@/services/api/bundle-discount'
import { createUsualPowerGetService, UsualPower } from '@/services/api/usual-power/usual-power'
import CartEnvironmentService from '@/services/environment/cart'
import FreeAreaService from '@/services/free-area/free-area'
import { NoveltyService } from '@/services/novelty.ts'
import { CampaignConstraint } from '@/usecases/novelty/campaign-constraint'
import { CampaignSummary } from '@/usecases/novelty/campaign-summary'
import MATag from '@/util/ma-tag'
import CALinkTag from '@/util/ma-tag/ca-link'
import HeaderBottomUserNotification from '@ajax/vue/components/templates/HeaderBottomUserNotification.vue'
import Fade from '@spa/components/atoms/transition/Fade.vue'
import BundleRecommendation from '@spa/components/organisms/cart/bundle-recommendation/BundleRecommendation.vue'
import CartHeader from '@spa/components/organisms/cart/CartHeader.vue'
import NoItem from '@spa/components/organisms/cart/NoItem.vue'
import NoveltySection from '@spa/components/organisms/cart/novelty/NoveltySection.vue'
import { NoveltyEntity } from '@spa/components/organisms/cart/novelty/selection'
import { convertToUseCaseState } from '@spa/components/organisms/cart/novelty/util'
import PopularItems from '@spa/components/organisms/cart/recommend/PopularItems.vue'
import PriceRangeItems from '@spa/components/organisms/cart/recommend/PriceRangeItems.vue'
import RemovedItem from '@spa/components/organisms/cart/RemovedItem.vue'
import SameDayShippingCountdown from '@spa/components/organisms/cart/SameDayShippingCountdown.vue'
import ReorderNotification, { ReorderNotificationDep } from '@spa/components/organisms/mypage/order/reorder/ReorderNotification.vue'
import { StickyType } from '@spa/components/organisms/sticky/model/Types'
import Sticky from '@spa/components/organisms/sticky/Sticky.vue'
import BundleDiscountSection from '@spa/components/pages/cart/components/cart/BundleDiscountSection.vue'
import { CartPageProps } from '@spa/components/pages/cart/model/cart/props'
import { toQuery } from '@spa/components/pages/order/scope-transpiler'
import { Order } from '@spa/store/modules/orderHistory/types'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CartService } from '@spa/services/api/cart'
import { CookieService } from '@spa/services/cookie'

import {
  extractDisplayedPurchasableItems,
  isSinglePurchasable,
  isSubscriptionItem,
  totalCountInScope,
  totalPriceInScope,
} from '@spa/store/modules/cart/function'
import { CartItem } from '@spa/store/modules/cart/types'
import { Either, Left, Right } from 'fp-ts/lib/Either'
import _ from 'lodash'
import scrollToElement from 'scroll-to-element'
import Vue from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop, Watch } from 'vue-property-decorator'
import CartItemListView from './components/cart/CartItemList.vue'
import { interaction } from './interaction/interaction'
import { CartPageQuery, HavingPreSalesItemsState } from './model/Cart'
import { isConfirmedFreeShippingByItem } from './model/free-shipping/free-shipping-by-item'
import { MembershipPlanPromotionPolicy } from './model/membership-promotion/promotion-policy'
import { getReorderNotificationView } from './model/reorder-notification/reorder-notification-view'
import { orderDeadlineForSameDayShipping } from './model/same-day-shipping/same-day-shipping-countdown'

import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { User } from '@spa/store/modules/user/types'

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({
  components: {
    BundleRecommendation,
    CartHeader,
    Fade,
    NoItem,
    NoveltySection,
    RemovedItem,
    SameDayShippingCountdown,
    SpaErrorDialog,
    Sticky,
    PriceRangeItems,
    PopularItems,
    SwitchByUa,
    ConfirmModal,
    CartItemListView,
    BundleDiscountSection,
    ReorderNotification,
    HeaderBottomUserNotification,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Cart
  extends Mixins<PluginMixin & WithConfirmModal>(PluginMixin, WithConfirmModal) implements CartPageProps {
  @Prop({ required: true })
  readonly scope: CartScopeEq

  @Prop({ required: true })
  readonly cartService: CartService

  @Prop({ required: true })
  readonly freeAreaService: FreeAreaService

  @Prop({ required: true })
  readonly noveltyService: NoveltyService

  @Prop({ required: true })
  readonly bundleDiscountService: BundleDiscountService

  @Prop({ required: true })
  readonly context: ContextToCreateUrl

  Status = Status

  status: Status = Status.Loading
  noveltyStatus: Status = Status.Loading
  applyBundleStatus: Status = Status.Loading

  showModal: boolean = false

  modalMessage: string = ''

  isCartIn: boolean = false

  latestOrder: Order | null = null

  freeAreaTop: ApiContent | null = null
  freeAreaMiddle: ApiContent | null = null
  freeAreaBottom: ApiContent | null = null

  // From the operational point of view, there is always up to a single novelty campaign.
  noveltyCampaign: NoveltyCampaign | null = null
  noveltyEntities: NoveltyEntity[] = []
  noveltyEndpage: ApiContent | null = null

  appliedBundleDiscounts: AppliedBundleDiscount[] = []
  bundleDiscounts: BundleDiscountWithBrand[] = []
  appliedDiscountPrice: number = 0

  maTag: MATag | null = null

  /**
   * store上でremovedフラグで管理していたが、
   * - カートの個数を変更するたびに価格やその価格が適用できる個数が変化する可能性が生じた
   *   - 有料会員価格の要件として
   *   - したがって、個数変更するたびにカートはサーバーから取得した状態で描画したい
   *     - storeを都度force loadしたい
   *   - 一方で、サーバーには「一度は削除されたカートを元に戻す機能」のための情報は存在しない
   * - そもそも削除したものをまた戻したいというのはstoreで実装する必要はない
   *   - このCartコンポーネントに閉じた操作およびそのためのデータ
   * という理由で、Vueコンポーネントのdataとして管理することにした。
   */
  removedItems: CartItem[] = []

  usualPowerInfo: UsualPower | null = null

  async created() {
    await this.$store.dispatch('view/startLoading')
    await this.$store.dispatch('user/get')
    await this.setUrlToContinueShopping()

    // Read query parameter
    const { isCartIn } = this.$route.query as CartPageQuery
    this.isCartIn = isCartIn === 'true'

    try {
      // Critical APIの完了後、ローディング終了
      await this.initializeCriticalData()
      this.status = Status.Completed

      // Optional APIを遅延読み込み（エラーが発生してもページ表示は継続）
      this.initializeOptionalData().catch((error) => {
        log.warn('Optional data initialization failed, but page continues to work', error)
      })
    } catch (error) {
      log.error('Critical initialization failed', error)
      this.status = Status.Failed
      this.showErrorMessage('カート情報の読み込みに失敗しました。ページを再読み込みしてください。')
    } finally {
      // Critical APIの成功・失敗に関係なく必ず実行すべき処理
      this.finalizeInitialization()
    }
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get itemListPage(): string {
    return createItemListUrl(this.context)
  }

  get behavior(): BehaviorConfig {
    // TODO: service同様、DIする
    return BehaviorConfig.createFromBrand(this.brand)
  }

  get brand(): string | null {
    return this.scope.kind.isBrand ? this.scope.value.toString() : null
  }

  // override loading-mixin getter
  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get items(): CartItem[] {
    // 削除などの操作を可能とするため、不完全な状態のデータも表示する.
    // 一方で、カート画面で表示して良いデータのみをフィルタリングする.
    // このフィルタリングはカート画面固有のものなので、vuex storeでは行っていない
    return this.wholeItems.filter(isDisplayItem)
  }

  get isNoItem(): boolean {
    return this.items.length === 0 && this.removedItems.length === 0
  }

  get wholeItems(): CartItem[] {
    const items: CartItem[] = this.$store.getters['cart/currentItems']

    /**
     * 単発注文でない場合(at 2021/09/09時点ではサブスクリプションのみ)、
     * カート画面は経由しない/させないため、単発注文で購入可能な商品以外は取り除く
     * @see https://my-color.esa.io/posts/638
     */
    return items.filter(item => !isSubscriptionItem(item))
  }

  /**
   * Order.vueで「実際に注文されるカート」を絞り込んでいるのと同等の絞り込みを行う
   * @see https://github.com/my-color/front/pull/6645
   */
  isPurchasableCartItem(item: CartItem): boolean {
    return isSinglePurchasable(item)
  }

  get purchasableDisplayItemList(): CartItemList {
    return new CartItemList(this.$store.getters['cart/displayItemsWithFilter'](this.isPurchasableCartItem))
  }

  get novelties(): CartItem[] {
    const novelties: CartItem[] = this.$store.getters['cart/noveltyItems']

    const noveltyCampaign = this.noveltyCampaign

    if (noveltyCampaign === null) {
      return novelties
    }

    /**
     * Return only the available novelties under a present campaign.
     * TODO: Remove old novelties from the cart when a campaign finished or is altered.
     */
    return novelties.filter((novelty) => {
      return noveltyCampaign.noveltyList.some(n => n.fkuId === novelty.fkuId)
    })
  }

  get hasPreSalesItem(): boolean {
    return this.items.some(item => item.isPreSales)
  }

  get totalItemCount(): number {
    return totalCountInScope(this.wholeItems)
  }

  get totalPrice(): number {
    return totalPriceInScope(this.wholeItems)
  }

  /**
   * カート内商品すべての金額合計について、会員価格で購入した場合の最安値を算出する。
   */
  get membershipPlanPromotionPolicy(): MembershipPlanPromotionPolicy {
    return new MembershipPlanPromotionPolicy(
      { isEnabled: this.behavior.paidMembership.enabled },
      { isPaidMember: this.$store.getters['user/isPaidMember'] },
      this.purchasableDisplayItemList
    )
  }

  get urlToContinueShopping() {
    return this.$store.getters['history/urlToContinueShopping']
  }

  get modeOfAddToCartButton(): string {
    return this.isAddToCartDisabled ? 'disabled--large' : 'primary c-btn--register'
  }

  get isAddToCartDisabled(): boolean {
    return this.totalItemCount === 0
  }

  get sameDayShippingOrderDeadline(): Date | null {
    return orderDeadlineForSameDayShipping(this.purchasableDisplayItemList.list)
  }

  /**
   * これが true のときに「あと〜円で送料無料」の訴求が出ないのは、fixedShippingFee の対象商品がここで判定する購入対象の商品を含み、
   * 送料無料フラグで 0 円に上書きされるため。どちらの対象商品を変えるときも、この包含関係を保つこと。
   */
  get isFreeShippingByItem(): boolean {
    return isConfirmedFreeShippingByItem(this.purchasableDisplayItemList.list)
  }

  get stickyType(): StickyType {
    return StickyType.TOP
  }

  /** 対象商品を変えるときは isFreeShippingByItem の docblock を参照 */
  get fixedShippingFee(): ShippingFee {
    return SelectShippingFee.createWithBehaviorConfig(
      this.freeShippingSubjectedPrice,
      this.behavior,
      this.wholeItems
    ).selectFixedFee()
  }

  get shouldShowRecommendItems(): boolean {
    if (!this.behavior.cart.promotion.freeShipping.show) {
      return false
    }

    /**
     * 合計金額は合計金額で表示しつつ、ユーザーに対する「あと〜X円で送料無料」のメッセージは通常注文のみを基準として表示する.
     * 送料無料の計算は注文ごとに行う.
     * 予約注文であっても、その注文の金額次第では送料無料になる.
     *
     * FIXME:
     * CartHeader.remainingPriceForFreeShippingMessage とで
     * 「送料無料までの計算基準には、送料無料対象外の商品のみを用いる」
     * という知識が分散している
     *
     * @see https://github.com/my-color/front/issues/536
     * @see https://my-color.esa.io/posts/362
     */
    if (this.isFreeShipping) {
      return false
    }

    if (this.havingPreSalesItemsState === HavingPreSalesItemsState.All) {
      return false
    }

    return !!this.fixedShippingFee.remainingPriceUntilFreeShipping()
  }

  get isFreeShipping(): boolean {
    return this.$store.getters['cart/isFreeShippingOnCatalogOnly']
  }

  get havingPreSalesItemsState(): HavingPreSalesItemsState {

    if (_.every(this.items, item => item.isPreSales)) {
      return HavingPreSalesItemsState.All
    }

    if (_.some(this.items, item => item.isPreSales)) {
      return HavingPreSalesItemsState.Included
    }

    return HavingPreSalesItemsState.None
  }

  get freeShippingSubjectedPrice(): number {
    return new CartItemList(
      /**
       * 予約商品は予約でない通常商品と発送時期が分かれるので、通常商品だけを送料無料の計算に用いる。
       * @see https://github.com/my-color/growthpalette-front/pull/7567/files#r1360350233
       */
      extractDisplayedPurchasableItems(this.wholeItems.filter(item => !item.isPreSales))
    ).totalPrice
  }

  get reorderNotificationData(): ReorderNotificationDep | undefined {
    if (!this.latestOrder) {
      return undefined
    }

    return getReorderNotificationView(
      ContextFactory.fromStore(this.latestOrder).create(),
      this.behavior
    ).toUndefined()
  }

  get noveltyCampaignName(): string {
    if (!this.noveltyCampaign) {
      return ''
    }

    return this.noveltyCampaign.campaign.title
  }

  get noveltySummary(): CampaignSummary | null {
    if (!this.noveltyCampaign || this.noveltyEntities.length === 0) {
      return null
    }

    return new CampaignSummary(
      this.noveltyCampaign!,
      convertToUseCaseState(this.noveltyEntities),
      new CartItemList(this.wholeItems),
      {
        discount: this.appliedDiscountPrice,
      }
    )
  }

  get noveltyConstraint(): CampaignConstraint | null {
    if (!this.noveltySummary) {
      return null
    }

    return new CampaignConstraint(this.noveltySummary)
  }

  get shouldShowNoveltySection(): boolean {
    /**
     * FIXME: ノベルティの初期化を子コンポーネントで都度行うのではなく、親で初期化した結果を子に流す
     *
     * ノベルティの(APIコールを除く)初期化処理が子コンポーネントで行われてしまっている.
     * そのため、情報が不完全(noveltySummary === null)だからといって
     * ノベルティセクションを非表示にすると、初期化自体が完了せず、表示すべきものが表示されない.
     *
     * そのため、子コンポーネントでnullエラーが出るのを承知で、やむなくチェックから外している.
     * エラーが出ると表示はされないが初期化は走るので、親コンポーネントまでイベントが伝播し、
     * 結果的に、表示自体はなんとかされる.
     */
    return !!this.noveltyCampaign &&
      // this.noveltySummary !== null &&
      this.novelties &&
      !this.shouldShowNoveltyError &&
      !this.shouldShowNoveltyHasNoStock
  }

  get shouldShowNoveltyNotAllowedForPreSales(): boolean {
    if (!this.noveltyCampaign || !this.noveltySummary) {
      return false
    }

    return this.noveltySummary.totalCount > 0 && this.hasPreSalesItem
  }

  get shouldShowNoveltyError(): boolean {
    return this.noveltyStatus === Status.Failed
  }

  get shouldShowNoveltyHasNoStock(): boolean {
    if (!this.noveltySummary) {
      return false
    }

    return !this.noveltySummary.userCanChangeCount
  }

  @Watch('items', { immediate: true })
  updateMATag(): void {
    if (!this.maTag) this.maTag = new CALinkTag()

    this.maTag.fkuIds = this.items.map(item => item.fkuId)
    this.maTag.setHtmlMetaElementTo(document)
  }

  beforeRouteLeave(_to, _from, next) {
    this.$store.commit('cart/isReplacedForSale', false)
    next()
  }

  shouldApplyBundleDiscount(): boolean {
    return CookieService.isLogined()
  }

  @Watch('totalItemCount', { immediate: true })
  async applyDiscount() {
    if (!this.shouldApplyBundleDiscount()) {
      return
    }
    const validItems = extractDisplayedPurchasableItems(this.wholeItems)

    this.applyBundleStatus = Status.Loading

    const applyDiscountResult = await this.bundleDiscountService.apply(
      convertToApplyBundleDiscountParamter(validItems)
    )

    applyDiscountResult.map(({ appliedBundleDiscounts, discount, bundleDiscounts }) => {
      this.appliedBundleDiscounts = appliedBundleDiscounts
      this.bundleDiscounts = bundleDiscounts
      this.appliedDiscountPrice = discount

      this.applyBundleStatus = Status.Completed
    }).mapLeft((error) => {
      if (error.isDueToBundleDiscountUnsupported) {
        this.bundleDiscounts = []
        this.appliedDiscountPrice = 0

        this.applyBundleStatus = Status.Completed

        return
      }

      this.applyBundleStatus = Status.Failed

      this.modalMessage = 'エラーが発生しました。<br/>合計金額の取得に失敗しました。'
      this.showModal = true
      this.status = Status.Failed
    })
  }

  async updateItem(updated: CartItem, newCount: number): Promise<void> {
    this.status = Status.Loading
    const id = updated.id

    const updateItemCount = interaction.updateItemCount({
      updateItemCountService: this.updateItemCountInCartService,
    })
    const result = await updateItemCount({ id, newCount, wholeItems: this.wholeItems })

    if (result.isLeft()) {
      log.error(result.value)
      this.modalMessage = result.value.message
      this.showModal = true
      this.status = Status.Failed

      return
    }

    /**
     * カートが変更されれば、
     * - 適用できる価格
     * - 価格が適用できる残個数
     * が変更になる可能性があるのでロードする
     *
     * TODO:
     * 個数変更イベントそのものの知識ではないので、カートが変更されたというイベントをemitして、
     * その購読側でstoreの同期を行ったほうが良さそう
     * @see https://github.com/my-color/front/pull/6205#discussion_r832360762
     */
    await this.loadCartItems()
    const item = this.$store.getters['cart/getItem'](id)

    if (_.get(item, 'error.update')) {
      this.modalMessage = 'エラーが発生しました。<br/>数量の変更に失敗しました'
      this.showModal = true
      this.status = Status.Failed

      return
    }

    this.status = Status.Completed
  }

  async removeItem(removed: CartItem): Promise<void> {
    const id = removed.id
    this.status = Status.Loading

    const removeCart = interaction.removeCart({ removeService: this.removeItemFromCartService })
    const result = await removeCart({ id, wholeItems: this.wholeItems })
    if (result.isLeft()) {
      log.error(result.value)
      this.modalMessage = 'エラーが発生しました。<br/>カート内の商品を削除できませんでした。'
      this.showModal = true
      this.status = Status.Failed

      return
    }

    removed.removed = true
    this.removedItems = [...this.removedItems, removed]

    /**
     * storeをEngineの状態と同期する
     *
     * TODO:
     * 削除イベントそのものの知識ではないので、カートが変更されたというイベントをemitして、
     * その購読側でstoreの同期を行ったほうが良さそう
     * @see https://github.com/my-color/front/pull/6205#discussion_r832360762
     */
    await this.loadCartItems()

    this.status = Status.Completed
  }

  restoreItem(item: CartItem): () => Promise<void> {
    return async() => {
      this.status = Status.Loading

      const restoreCart = interaction.restoreCart({
        restoreService: RestoreRemovedItemFromCartService.create(this.cartItemRepository),
      })
      const result = await restoreCart({
        id: item.id,
        wholeItems: this.wholeItems,
        removedItems: this.removedItems,
      })
      if (result.isLeft()) {
        log.error(result.value)
        this.modalMessage = result.value.message
        this.showModal = true
        this.status = Status.Failed

        return
      }

      this.removedItems = this.removedItems.filter(removed => removed.id !== item.id)

      /**
       * storeをEngineの状態と同期する
       *
       * TODO:
       * カートを元に戻すイベントそのものの知識ではないので、カートが変更されたというイベントをemitして、
       * その購読側でstoreの同期を行ったほうが良さそう
       * @see https://github.com/my-color/front/pull/6205#discussion_r832360762
       */
      await this.loadCartItems()

      this.status = Status.Completed
    }
  }

  handleNextPageClick(): void {
    if (this.shouldShowNoveltyNotAllowedForPreSales) {
      this.showNoveltyNotAllowedForPreSales()

      return
    }

    if (this.noveltyConstraint && !this.noveltyConstraint.isValid) {
      this.showNoveltyConstraint()

      return
    }

    if (this.shouldShowEmptyNoveltyConfirm) {
      this.confirm()

      return
    }

    this.goToNextPage()
  }

  get shouldShowEmptyNoveltyConfirm(): boolean {
    if (!this.noveltySummary) {
      return false
    }

    return this.noveltySummary.isNotYetSelected
  }

  /**
   * カウントダウンが消えると sticky の中身が縮む。縮んだ DOM が描かれてから Sticky に測り直させる。
   */
  handleSameDayShippingExpired(): void {
    this.$nextTick(() => (this.$refs['cart-checkout-buttons'] as Sticky).refreshHeight())
  }

  handleNoveltyConfirmModalCancel(): void {
    this.onConfirmModalCancel()
    this.goToNextPage()
  }

  async goToNextPage(): Promise<void> {
    if (!this.verifyCartItemsCount()) {
      this.modalMessage = '一度にご注文できる商品の上限数を超えています。商品数を減らしてからご注文ください。'
      this.showModal = true
      this.status = Status.Completed

      return
    }

    this.navigateToOrder()
  }

  // tslint:disable:max-line-length
  /**
   * @deprecated クライアントでの整合性チェックは廃止して、サーバー側に集約させるべき
   * @see https://github.com/my-color/front/issues/7612
   * @see https://github.com/my-color/front/blob/develop/src/Model/Cart/ConsistenceSpec/Policy/WholeCart/DefaultPolicy.php この実装に集約させたい
   */
  // tslint:enable:max-line-length
  verifyCartItemsCount(): boolean {
    const items: CartItem[] = this.$store.getters['cart/items']
    /**
     * ユーザーが購入を意図している商品
     * ノベルティはユーザーの意図としては購入の対象ではない
     * @see https://github.com/Everforth/growthpalette-front/issues/8577
     */
    const userIntendedPurchaseItems = items.filter(item => !item.isNovelty)
    const totalCountOfCartItems = userIntendedPurchaseItems
      .map(item => item.unitCount)
      .reduce((sum, count) => sum + count, 0)

    const kindLimit = parseInt(process.env.LIMIT_CART_ITEMS || '15', 10)
    const countSumLimit = new CartEnvironmentService().limitCartUnitCount

    return userIntendedPurchaseItems.length <= kindLimit && totalCountOfCartItems <= countSumLimit
  }

  navigateToOrder(): void {
    this.$router.push({
      path: '/order',
      query: {
        scope: toQuery(this.scope),
      },
    })
  }

  async setUrlToContinueShopping() {
    await this.$store.dispatch('history/setUrlToContinueShopping')
  }

  handleNoveltyEntitiesInit(entities: NoveltyEntity[]): void {
    this.noveltyEntities = entities
  }

  /**
   * Novelty handling
   */
  async handleNoveltyEntitiesChange(entities: NoveltyEntity[], changedIndex: number): Promise<void> {
    /**
     * When changed states are invalid, listen to 'constraint-error' event.
     * Do not handle the error here.
     */
    this.noveltyEntities = entities
    this.status = Status.Loading

    const changedItem = this.noveltyEntities[changedIndex]
    const command = this.commandToSaveNoveltySpec.select(changedItem, this.novelties)

    const result = await command()

    result.
      map(async () =>
        this.$store.dispatch('cart/loadNovelties')
      )
      .mapLeft(async (error) => {
        log.error({ error })

        this.showModal = true
        this.modalMessage = 'ノベルティ商品の数量変更に失敗しました'
        this.status = Status.Completed
      })
      .map(async (promise) => {
        await promise

        this.status = Status.Completed
      })
  }

  handleNoveltyConstraintError(val: Error): void {
    log.error(val)

    this.showNoveltyConstraint()
  }

  async handleResetNoveltySelection(val: Error): Promise<void> {
    log.error(val)

    this.status = Status.Loading

    try {
      await this.$store.dispatch('cart/resetNovelties', {
        repository: this.cartItemRepository,
        novelties: this.novelties,
      })
    } catch (e) {
      log.error({ resetNoveltiesError: e })
    } finally {
      this.status = Status.Completed
    }

    this.showResetNoveltySelection()
  }

  /**
   * ノベルティ選択欄までスクロールする
   * @see https://github.com/my-color/front/pull/7504
   */
  handleNoveltyConfirmModalOk() {

    const noveltySection = $('#novelty-section').get()[0]

    if (noveltySection) {
      const offset = - this.getHeaderHeight() - this.getCartButtonsHeight()

      scrollToElement(noveltySection, {
        offset,
        ease: 'in-sine',
        duration: 300,
      })
    }

    this.onConfirmModalOk()
  }

  private getHeaderHeight(): number {
    const headerElement = document.querySelector('header')

    if (headerElement) {
      const headerClientRect = headerElement.getBoundingClientRect()

      return headerClientRect ? headerClientRect.height : 0
    }

    return 0
  }

  private getCartButtonsHeight(): number {
    const cartCheckoutButtons = this.$refs['cart-checkout-buttons'] as Vue
    const cartCheckoutButtonsHeight = cartCheckoutButtons.$el.clientHeight

    return cartCheckoutButtonsHeight ? cartCheckoutButtonsHeight : 0
  }

  private showErrorMessage(message: string): void {
    this.modalMessage = message
    this.showModal = true

    return
  }

  private showNoveltyNotAllowedForPreSales(): void {
    this.showErrorMessage(
      '予約注文がある場合はノベルティを選択いただけません。ノベルティの選択を外していただくか、予約商品は別途ご注文ください。'
    )
  }

  private showNoveltyConstraint(): void {
    this.showErrorMessage(
      'ノベルティを選択いただける範囲を越えています。ノベルティの個数を変更してください。'
    )
  }

  private showResetNoveltySelection(): void {
    this.showErrorMessage(
      'ノベルティを選択いただける範囲を越えているため、選択を解除しました。再度ご確認の上選択してください。'
    )
  }

  /**
   * Critical APIs - 失敗したらコンポーネント全体をエラーとし後続処理を中断
   */
  private async initializeCriticalData(): Promise<void> {
    await this.loadCartItemsOrFail()
  }

  /**
   * Non-critical APIs - 失敗してもコンポーネント動作を継続
   */
  private async initializeOptionalData(): Promise<void> {
    // ノベルティが開催中でない場合はノベルティ商品を削除するので、
    // カート読み込みが終わった後で実行 (loadNoveltySafely)
    const [latestOrderResult, freeAreaResult, noveltyResult, usualPowerResult] = await Promise.all([
      this.loadLatestOrderSafely(),
      this.loadFreeAreaSafely(),
      this.loadNoveltySafely(),
      this.loadUsualPowerSafely(),
    ])

    const errors: string[] = []

    // エラーログのみ（状態設定は各loadメソッド内で完了済み）
    if (latestOrderResult.isLeft()) {
      log.warn('Failed to load latest order', latestOrderResult.value)
    }

    if (freeAreaResult.isLeft()) {
      log.warn('Failed to load free area contents', freeAreaResult.value)
    }

    if (noveltyResult.isLeft()) {
      log.error('Failed to load novelty campaign', noveltyResult.value)
      errors.push('ノベルティの情報が取得できませんでした。')
    }

    if (errors.length > 0) {
      this.showErrorMessage(errors.join('<br>'))
    }

    if (usualPowerResult.isLeft()) {
      log.warn('Failed to load usual power info', usualPowerResult.value)
    }
  }

  private finalizeInitialization(): void {
    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
    EventBusForThirdParty.getInstance().publish('cart-view', {
      wholeItems: this.wholeItems,
      purchasableDisplayItemList: this.purchasableDisplayItemList,
      totalPrice: this.totalPrice,
    })

    // Initial error message
    if (this.shouldShowNoveltyNotAllowedForPreSales) {
      this.showNoveltyNotAllowedForPreSales()
    }
  }

  private loadCartItems(): Promise<void> {
    return this.$store.dispatch('cart/loadWithScope', {
      force: true,
      scope: this.scope,
    })
  }

  /**
   * Critical APIs用 - カート情報をロードする（エラーが発生した場合は例外を投げる）
   */
  private async loadCartItemsOrFail(): Promise<void> {
    log.debug('Cart loadCartItemsOrFail: Starting load')

    await this.loadCartItems()

    log.debug('Cart loadCartItemsOrFail: Vuex dispatch completed')

    // Vuexでエラーが発生した場合は明示的にエラーを投げる
    const cartState = this.$store.state.cart
    log.debug('Cart loadCartItemsOrFail: Checking cart state for errors', { error: cartState.error })

    if (cartState.error && cartState.error.load) {
      const error = new Error(`Failed to load cart items: ${cartState.error.load.message || 'Unknown error'}`)
      log.error('Cart load failed in Vuex store', cartState.error.load)

      throw error
    }

    log.debug('Cart loadCartItemsOrFail: Completed successfully')
  }

  /**
   * 最新注文履歴をロードする（静かに失敗）
   */
  private async loadLatestOrderSafely(): Promise<Either<Error, void>> {
    try {
      const latestOrder = await this.$store.getters['orderHistory/getLatest'](this.scope) || null
      this.latestOrder = latestOrder

      return new Right(undefined)
    } catch (error) {
      this.latestOrder = null

      return new Left(error instanceof Error ? error : new Error(String(error)))
    }
  }

  /**
   * 「いつもの度数」情報をロードする（静かに失敗）
   */
  private async loadUsualPowerSafely(): Promise<Either<Error, void>> {
    try {
      const usualPowerService = createUsualPowerGetService(this.brand)
      const usualPowerResult = await usualPowerService.getUserInfo()
      this.usualPowerInfo = usualPowerResult.fold(
        (error) => {
          log.warn('Failed to get usual power info', error)

          return null
        },
        data => data
      )

      return new Right(undefined)
    } catch (error) {
      this.usualPowerInfo = null

      return new Left(error instanceof Error ? error : new Error(String(error)))
    }
  }

  /**
   * フリーエリアコンテンツをロードする（静かに失敗）
   */
  private async loadFreeAreaSafely(): Promise<Either<Error, void>> {
    try {
      const freeAreaResult = await this.freeAreaService.fetch()

      if (freeAreaResult && freeAreaResult.length > 0) {
        const [topContent, middleContent, bottomContent, noveltyContent] = freeAreaResult
        this.freeAreaTop = topContent || null
        this.freeAreaMiddle = middleContent || null
        this.freeAreaBottom = bottomContent || null
        this.noveltyEndpage = noveltyContent || null
      }

      return new Right(undefined)
    } catch (error) {
      // エラー時はundefinedのままにする（テンプレートでガードされる）
      return new Left(error instanceof Error ? error : new Error(String(error)))
    }
  }

  /**
   * ノベルティキャンペーンをロードする（静かに失敗）
   */
  private async loadNoveltySafely(): Promise<Either<Error, void>> {
    const result = await this.loadNovelty()

    if (result.isLeft()) {
      this.noveltyStatus = Status.Failed

      return new Left(result.value)
    }
    this.noveltyCampaign = result.value
    this.noveltyStatus = Status.Completed

    return new Right(undefined)
  }

  private async loadNovelty(): Promise<Either<Error, NoveltyCampaign | null>> {
    let promiseCleanUp = Promise.resolve()

    this.cleanUpUnpublishedNoveltyItemObserver
      .onFinishCleanUp(() =>
        // TODO: カート情報をアレコレした時、いちいち呼び直さなくても良いようにしたい。
        // イベント駆動的に、ストアが関わる情報が更新されたら、勝手にストアで再読み込みが走るイメージ
        promiseCleanUp = this.loadCartItems()
      ).onErrorInCleanUp(() => {
        promiseCleanUp = Promise.reject(new Error('error occured in clean up'))
      })

    const result = await this.noveltyService.getFirst()

    return promiseCleanUp
      .then(() => result)
      .catch(error => new Left<Error, NoveltyCampaign | null>(error))
  }

  get commandToSaveNoveltySpec(): CommandToSaveNoveltySpec {
    return CommandToSaveNoveltySpec.create({
      create: selectedNovelty =>
        this.cartService.add(
          selectedNovelty.item.skuId,
          selectedNovelty.state.count,
          /**
           * ノベルティ価格は0という前提を置いている。
           * 仮にこの前提が変わる場合は、動的に価格を取得してくること。
           */
          0,
          // 価格は0以下にならないので、会員価格という概念は存在しない。
          false
        )
        .then(e => e.map(() => null)),
      update: (selectedNovelty, cartItem) =>
        this.cartService.updateUnitCount(
          cartItem.id,
          selectedNovelty.state.count
        )
        .then(e => e.map(() => null)),
      delete: (_selectedNovelty, cartItem) =>
        this.cartService.remove(cartItem.id)
        .then(e => e.map(() => null)),
      default: (selectedNovelty, cartItem) => Promise.resolve().then(() => {
        log.debug({ selectedNovelty, cartItem, message: 'novelty action is ignored' })

        return new Right(null)
      }),
    })
  }

  private get cleanUpUnpublishedNoveltyItemObserver(): CleanUpUnpublishedNoveltyItemObserver {
    return CleanUpUnpublishedNoveltyItemObserver.create(
      {
        items: new CartItemList(this.novelties),
      },
      this.noveltyService,
      RemoveItemFromCartService.create(this.cartItemRepository)
    )
  }
  private get updateItemCountInCartService(): UpdateItemCountInCartService {
    return UpdateItemCountInCartService.create(this.cartItemRepository)
  }
  private get removeItemFromCartService(): RemoveItemFromCartService {
    return RemoveItemFromCartService.create(this.cartItemRepository)
  }
  private get cartItemRepository(): CartItemRepository {
    return new EngineCartRepository()
  }
}
